<template>
  <main :class="{'boxPadding': isBox}">
    <section class="search container">
      <div class="row">
        <div class="col-12">
          <form class="form">
            <div class="input-group input-lg">
              <div class="input">
                <input
                type="text"
                name="keyword"
                id="keyword"
                class="form-control"
                v-model="keyword"
                @keydown.enter="doSearch()"
                placeholder="輸入群組名稱查詢" alt="ch"
                maxlength="20"
                @input="checkKeyword"
                @blur="checkKeyword">
              </div>
              <button
              class="btn btn-primary btn-icon"
              type="submit"
              @click.prevent="doSearch()">
                <i class="icon-search i-24"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
    
    <div :class="{'section-loading': custsOfAgntIsLoading}" class="container pt-4">
      <h4 class="text-green">
        群組列表
        <a class="btn btn-default btn-sm m-0 ml-3"
        @click="createGroup()">
          新增群組
        </a>
         <div class="dropdown float-right">
          <button
            class="btn btn-default btn-sm m-0"
            aria-expanded="false"
            aria-haspopup="true"
            data-toggle="dropdown"
            @click="dropmenuOpen = !dropmenuOpen"
          >
            {{ filterStr
            }}<i v-if="dropmenuOpen === false" class="icon-collapse_down"></i
            ><i v-else class="icon-collapse_up"></i>
          </button>
          <div class="dropdown-menu  dropdown-menu-left">
            <a
              @click="filterGrpsOfAgnt('1')"
              role="button"
              class="dropdown-item text-green text-underline"
              >異動時間由新到舊</a
            >
            <a
              @click="filterGrpsOfAgnt('2')"
              role="button"
              class="dropdown-item text-green text-underline"
              >異動時間由舊到新</a
            >
            <a
              @click="filterGrpsOfAgnt('3')"
              role="button"
              class="dropdown-item text-green text-underline"
              >名稱筆劃由少到多</a
            >
            <a
              @click="filterGrpsOfAgnt('4')"
              role="button"
              class="dropdown-item text-green text-underline"
              >名稱筆劃由多到少</a
            >
          </div>
        </div>
      </h4>
      <div class="list group" v-if="grpsOfAgnt.length != 0">
        <div class="item"
        v-for="(item, i) in grpsOfAgnt"
        :key="`group-item-${i}`">
          <div class="name">
            <router-link :to="{ path:`/group/${i}`, query:{grp_id: item.grp_id, grp_name: item.grp_name}}">
              <h4 class="link text-underline m-0">{{item.grp_name}}</h4>
            </router-link>
          </div>
          <div class="action">
            <a role="button" class="btn btn-sm btn-default btn-icon my-0"
            @click="selectGroup(item)">
              <i class="icon-edit"></i>
            </a>
          </div>
        </div>
      </div>
      <div v-else class="text-center" colspan="6">
        <h3 class="mb-3">{{this.remoteDataMessage}}</h3>
      </div>
    </div>

    <warning-modal
    :open="warningModalOpen"
    :message="warningData[currentWarningType].message"
    @close="panelClose('warningModalOpen')"
    @submit="warningSubmit"/>

    <!-- <new-group
    :open="newGroupOpen"
    @close="panelClose('newGroupOpen')"
    @submit="addGroup"/> -->

    <add-group-modal
    :open="addGroupModalOpen"
    :is-edit="addGroupEdit"
    :currentGroup="selectedGroup"
    :custsOfAgnt="custsOfAgnt"
    :custsOfGrp="custsOfGrp"
    :custsOfAgntIsLoading="custsOfAgntIsLoading"
    :custsOfGrpIsLoading="custsOfGrpIsLoading"
    @close="panelClose('addGroupModalOpen')"
    @delete="beforeDel"
    @submit="addGroupMember"/>
  </main>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {commonMixin} from '../../mixins/common';
import WarningModal from '../components/WarningModal';
import NewGroup from '../components/NewGroup';
import AddGroupModal from '../components/AddGroupModal';

import { getCustomers } from '../../service';
import { getGroupOfAgnt } from '../../service';
import { getGroupOfAgntByName } from '../../service';
import { getGroupMember } from '../../service';
import { updateGroup } from '../../service';
import { updateGrpMem } from '../../service';
import { removeGrp } from '../../service';
import { log } from 'util';

export default {
  name: 'Group',
  mixins: [commonMixin],
  components: { WarningModal, NewGroup, AddGroupModal },
  data () {
    return {
      keyword: '',
      currentWarningType: 'confirmDel',
      newGroupOpen: false,
      addGroupModalOpen: false,
      addGroupEdit: true,
      warningModalOpen: false,
      oldGroup: null,
      warningData: {
        confirmDel: {
          message: '',
          submit: 'confirmDel'
        }
      },
      selectedGroup: {name: ''},
      selectedItem: 0,
      groups: {
        name: '滿期年金',
        edit: false
      },
      isEdit: false,
      custsOfAgntIsLoading: false,
      custsOfGrpIsLoading: false,
      custsOfAgnt: [],
      grpsOfAgnt: [],
      custsOfGrp: [],
      remoteDataMessage: '資料讀取中，請稍候...',
      dropmenuOpen: false, //篩選下拉選單的箭頭是否向上
      filterStr: "群組排序方式"
    }
  },
  computed: {
    ...mapGetters(['UserInfo']),
    isBox() {
      return this.UserInfo.userType === 'box';
    }
  },
  methods: {
    //檢查輸入欄位
    checkKeyword(){
      this.keyword = this.keyword.replace(/[<>!#$^&,"'?%*;+{}[\]|~`=\\]/g,'');
    },
    ...mapActions([
      'setPageLock'
    ]),
    createGroup () {
      this.$router.push({name:'group-member-new', params:{grp_id:'', grp_name:'', custsOfGrp:[]}});
    },
    selectGroup (group) {
      this.custsOfAgntIsLoading = true
      getGroupMember(this.$store.state.userInfo.id, group.grp_id).then(result => {
        if(result) {
          this.custsOfGrp = result.map(cust => {
            return {
              name: cust.NAME || '',
              identity: cust.ID || '',
              birthday: cust.BIRTHDAY || '',
              showid: cust.ID && cust.ID.includes('~') ? '' : cust.ID,
              gender: cust.SEX || ''
            }
          })
        } else {
          this.custsOfGrp = []
        }
        this.custsOfAgntIsLoading = false
        this.$router.push({name:'group-member-new', params:{grp_id:group.grp_id, grp_name:group.grp_name, custsOfGrp:this.custsOfGrp}});
      })
    },
    confirmDel () {
      let currentGroup = this.grpsOfAgnt[this.selectedItem]
      removeGrp(this.$store.state.userInfo.id, this.$store.state.userInfo.id, currentGroup.grp_id).then(result => {
        if(result.header.status === '200') {
          this.grpsOfAgnt.splice(this.selectedItem, 1)
          this.$toast.info({title: result.header.message})
        } else {
          this.$toast.info({title: result.header.message})
        }
      })
    },
    beforeDel () {
      this.panelClose('addGroupModalOpen')
      this.currentWarningType = 'confirmDel'
      this.warningData.confirmDel.message = `請確認是否刪除該群組及群組成員？`
      this.panelOpen('warningModalOpen')
    },
    warningSubmit () {
      let fn = this.warningData[this.currentWarningType].submit
      this[fn]()
      this.panelClose('warningModalOpen')
    },
    toggleEdit (i) {
      this.groups[i].edit = true
      this.isEdit = true
      this.currentEdit = i
    },
    // addGroup (item) {
    //   this.groups.push({
    //     grp_id: item.grp_id,
    //     grp_name: item.grp_name,
    //     edit: false
    //   })
    //   this.panelClose('newGroupOpen')
    //   this.panelOpen('addGroupModalOpen')
    //   this.selectedGroup = this.groups[this.groups.length - 1]
    // },
    addGroupMember (group, members) {
      
      let memList = []
      let copmreMap = {}
      members.forEach(ele => {
        memList.push(ele.identity)
        copmreMap[ele.identity] = ele.name
      });

      this.panelClose('addGroupModalOpen')
      if(!this.addGroupEdit) {
        updateGroup(this.$store.state.userInfo.id, null, group.grp_name, members).then(result => {
          if(result.header.status && result.header.status == '200') {
            this.initGroupVue()
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: result.header.message})
          }
        })
      } else {
        updateGrpMem(this.$store.state.userInfo.id, group.grp_id, group.grp_name, memList).then(result => {
          if(result.header.status && result.header.status == '200') {
            this.groups[this.selectedItem] = group
            this.initGroupVue()
            this.$toast.info({title: result.header.message})
          } else {
            this.$toast.info({title: result.header.message})
          }
        })
      }
    },
    doSearch() {
      if (!this.$store.state.compositionStatus) {
        this.remoteDataMessage = '資料讀取中，請稍候...'
        getGroupOfAgntByName(this.$store.state.userInfo.id, this.$store.state.userInfo.id, this.keyword,0).then(result => {
          if(result.body.groups) {
            this.grpsOfAgnt = result.body.groups.map(item => {
              return {
                grp_id: item.grp_id,
                grp_name: item.grp_name,
                edit: false
              }
            })
          } else {
            this.grpsOfAgnt = []
          }
          this.remoteDataMessage = '查無資料，請確認您輸入之資料是否正確'
        })
      }
    },
    initGroupVue() {
      this.remoteDataMessage = '資料讀取中，請稍候...'
      this.custsOfAgntIsLoading = true 
      getGroupOfAgnt(this.$store.state.userInfo.id, this.$store.state.userInfo.id,0).then(result => {
        if(result.body.groups) {
          this.grpsOfAgnt = result.body.groups.map(item => {
            return {
              grp_id: item.grp_id,
              grp_name: item.grp_name,
              edit: false
            }
          })
        } else {
          this.grpsOfAgnt = []
        }
        this.remoteDataMessage = '查無資料，請確認您輸入之資料是否正確'
        this.custsOfAgntIsLoading = false
      })
      // this.custsOfAgntIsLoading = false // debug 專用

    },
    filterGrpsOfAgnt(filterCondition) {
      if (filterCondition === '1') {
        this.filterStr = "異動時間由新到舊";
      } else if (filterCondition === '2') {
        this.filterStr = "異動時間由舊到新";
      } else if (filterCondition === '3') {
        this.filterStr = "名稱筆劃由少到多";
      } else if (filterCondition === '4') {
        this.filterStr = "名稱筆劃由多到少";
      }
      if (this.keyword) {
        if (!this.$store.state.compositionStatus) {
          this.remoteDataMessage = "資料讀取中，請稍候...";
          getGroupOfAgntByName(
            this.$store.state.userInfo.id,
            this.$store.state.userInfo.id,
            this.keyword,
            filterCondition
          ).then(result => {
            if (result.body.groups) {
              this.grpsOfAgnt = result.body.groups.map(item => {
                return {
                  grp_id: item.grp_id,
                  grp_name: item.grp_name,
                  edit: false
                };
              });
            } else {
              this.grpsOfAgnt = [];
            }
            this.remoteDataMessage = "查無資料，請確認您輸入之資料是否正確";
          });
        }
      } else {
        this.remoteDataMessage = "資料讀取中，請稍候...";
        this.custsOfAgntIsLoading = true;
        getGroupOfAgnt(
          this.$store.state.userInfo.id,
          this.$store.state.userInfo.id,
          filterCondition
        ).then(result => {
          if (result.body.groups) {
            this.grpsOfAgnt = result.body.groups.map(item => {
              return {
                grp_id: item.grp_id,
                grp_name: item.grp_name,
                edit: false
              };
            });
          } else {
            this.grpsOfAgnt = [];
          }
          this.remoteDataMessage = "查無資料，請確認您輸入之資料是否正確";
          this.custsOfAgntIsLoading = false;
        });
      }
    }
  },
  mounted () {
    this.$store.dispatch('updaCustType',['1','2','3','4','5','6']) // initialize custType
    this.initGroupVue()


    // F5 重新整理方案

    // if(this.$store.state.userInfo.id === ''){
    //   setTimeout(() => {
    //     this.initGroupVue()
    //   }, this.$store.state.timeoutVal);
    // }else{
    //   this.initGroupVue()
    // }
  }
}
</script>

<style scoped>
.boxPadding {
  padding-top: 0px !important;
}
</style>